import {
  Box,
  Button,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getAssociatedUserMenu,
  setAssociatedUserMenu,
} from "./associatedUsersApi";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import iconExpenses from "../../assets/img/icons/expenses_icon.png";
import iconReports from "../../assets/img/icons/reports_icon.png";
import iconEmployeeMaster from "../../assets/img/icons/employee_master_icon.png";
import iconOffers from "../../assets/img/icons/offers_icon.png";
import iconInventory from "../../assets/img/icons/inventory_icon.png";
import iconAppointment from "../../assets/img/icons/appointment_icon.png";
import iconCustomerInfo from "../../assets/img/icons/customer_information_icon.png";
import iconMyBusiness from "../../assets/img/icons/my_business.png";
import iconShareMessages from "../../assets/img/icons/share_messages_icon.png";
import iconServicesProducts from "../../assets/img/icons/services_products_icon.png";
import iconEmployeeAccess from "../../assets/img/icons/employee_access_icon.png";
import iconOutstandingReceipts from "../../assets/img/icons/outstanding_payment_receipts_icon.png";
import iconDashboard from "../../assets/img/icons/dashboard_icon.png";
import iconBilling from "../../assets/img/icons/billing_icon.png";

const ScopeModal = ({ open, setOpen, selectedUser }) => {
  const [menu, setMenu] = useState([]);
  const imageIcons = [
    iconExpenses,
    iconEmployeeMaster,
    iconInventory,
    iconCustomerInfo,
    iconShareMessages,
    iconEmployeeAccess,
    iconDashboard,
    iconReports,
    iconOffers,
    iconAppointment,
    iconBilling,
    iconMyBusiness,
    iconServicesProducts,
    iconOutstandingReceipts,
    iconBilling,
  ];

  const getUserData = async (id) => {
    try {
      const res = await getAssociatedUserMenu(id);
      setMenu(res?.data?.data || []);
    } catch (err) {
      console.error("getAssociatedUserMenu error", err);
    }
  };

  const setUserMenu = async (param) => {
    try {
      await setAssociatedUserMenu(param);
      getUserData({ id: selectedUser?.associateUserId });
    } catch (err) {
      console.error("setAssociatedUserMenu error", err);
    }
  };

  useEffect(() => {
    if (open) {
      getUserData({ id: selectedUser?.associateUserId });
    }
  }, [open]);

  const update = () => {
    const arr = menu.map((item) => ({
      isRequired: item.isRequired,
      systemFuctionId: item.systemFuctionId,
    }));

    setUserMenu({
      associatedUserId: selectedUser?.associateUserId,
      systemMenu: arr,
    });
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={() => setOpen(false)}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
          backgroundColor: "#CECEFF",
          boxShadow: 3,
        }}
      >
        <Typography
          color="#000"
          fontWeight={500}
          fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
        >
          Scope
        </Typography>
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon sx={{ color: "#000" }} />
        </IconButton>
      </Box>

      <Divider />

      <DialogContent sx={{ p: 2, pt: 2 }}>
        <Grid container spacing={2}>
          {menu.map((item2, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box
                sx={{
                  borderBottom: "1px solid #7D7D7D",
                  height: "100%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    sx={{
                      justifyContent: "space-between",
                      m: 0,
                      flexDirection: "row-reverse",
                      alignItems: "center",
                    }}
                    control={
                      <Switch
                        checked={item2?.isRequired}
                        onChange={(e) => {
                          const updatedMenu = [...menu];
                          updatedMenu[index].isRequired = e.target.checked;
                          setMenu(updatedMenu);
                        }}
                      />
                    }
                    label={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={imageIcons[index]}
                          alt="icon"
                          style={{ width: 22, height: 22, marginRight: 8 }}
                        />

                        <Typography
                          color="primary"
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            // overflow: "hidden",
                            // textOverflow: "ellipsis",
                            // display: "-webkit-box",
                            // WebkitLineClamp: "1",
                            // WebkitBoxOrient: "vertical",
                          }}
                        >
                          {item2?.regionalFunctionName}
                        </Typography>
                      </Box>
                    }
                  />
                </FormGroup>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <Divider />
      <DialogActions
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Button
          sx={{ width: "60%" }}
          variant="contained"
          fullWidth
          onClick={() => {
            setOpen(false);
            update();
          }}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScopeModal;
